// composabels/useFilters.js

export function useFilters() {

    const formatDate = (date) => {
        if (!date) return '';
        // Suporta "2025-07-28 19:19:06" e "2025-07-28T19:19:06.000000Z"
        const [datePart] = date.split(/[ T]/);
        const parts = datePart.split('-');
        if (parts.length !== 3) return date;
        const [year, month, day] = parts;
        return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    };

    const formatDateTime = (date) => {
        if (!date) return '';
        // Suporta "2025-07-28 19:19:06" e "2025-07-28T19:19:06.000000Z"
        let datePart = '', timePart = '';
        if (date.includes('T')) {
            [datePart, timePart] = date.split('T');
            // Remove milissegundos e 'Z' se existirem
            timePart = timePart ? timePart.replace(/\..*$/, '').replace('Z', '') : '';
        } else {
            [datePart, timePart] = date.split(' ');
        }
        const parts = datePart.split('-');
        if (parts.length !== 3) return date;
        const [year, month, day] = parts;
        return timePart
            ? `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year} ${timePart.slice(0,5)}`
            : `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    }

    const parseDate = (date) => {
        if (!date) return '';
        // Suporta "2025-07-28 19:19:06" e "2025-07-28T19:19:06.000000Z"
        const [datePart] = date.split(/[ T]/);
        const parts = datePart.split('-');
        if (parts.length !== 3) return date;
        const [year, month, day] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    return {
        formatDate,
        formatDateTime,
        parseDate
    };

}